import React, { useState, useEffect } from 'react'
import ThemeMaker from '../../components/thememaker'
import { Collapse } from 'antd';
import axios from 'axios';
import { useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { config } from '../../utils/config';
import { toast } from 'react-toastify';
import "../../index.css";
import "../../components/mcrbTableTheme.css";
import dayjs from "dayjs";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { FaCheckCircle } from "react-icons/fa";
import { FaExclamationCircle } from "react-icons/fa";
import { Dropdown, Button, Checkbox, Form, Input, Select, Tag } from 'antd';
import { TimePicker } from 'antd';
import { useHistory } from 'react-router-dom';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};
export default function Addwarehouse() {
    const { id, locationId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const router = useHistory()
    const [form] = Form.useForm();
    const [Bankform] = Form.useForm();
    const [Feature] = Form.useForm();
    const [selectedState, setSelectedState] = useState("")
    const [sectionStatus, setSectionStatus] = useState({
        address: false,
        time: false,
        bank: false
    });

    useEffect(() => {
        if (selectedState === "") {
            return
        }
        getCitiesByState()
    }, [selectedState])
    useEffect(() => {
        getStatesByCountry()
    }, [])

    const [cities, setCities] = useState([])
    const [states, setStates] = useState([])
    const [value, setValue] = useState(null);

    async function getCitiesByState() {
        let key = "b4e03d17041262a06649f033f19da4f863d03734431444b7c4740991c86dff44"
        const response = await axios({
            url: `https://api.countrystatecity.in/v1/countries/IN/states/${selectedState}/cities`,
            headers: { 'X-CSCAPI-KEY': key }
        })

        if (response.status === 200) {
            console.log(response)
            setCities(response?.data)
        } else {
            console.error('State not found or no cities available');

        }

    }
    async function getStatesByCountry() {
        let key = "b4e03d17041262a06649f033f19da4f863d03734431444b7c4740991c86dff44"
        const response = await axios({
            url: `https://api.countrystatecity.in/v1/countries/IN/states`,
            headers: { 'X-CSCAPI-KEY': key }
        })

        if (response.status === 200) {
            console.log(response)
            setStates(response?.data)
        } else {
            console.error('State not found or no cities available');

        }

    }
    const onAccordianChange = (key) => {
        console.log(key);
    };

    const [allWeekTime, setAllWeekTime] = useState("")
    const onChange = (time, timeString) => {
        console.log(time);
        console.log("timeString-->", timeString);
        setAllWeekTime(timeString)
    };

    const [haveDifferentTime, setHaveDifferentTime] = useState(false)

    const onCheckboxChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
        setHaveDifferentTime(e.target.checked)
    };


    const onFinish = async (values) => {
        setIsLoading(true);
        try {
            const payload = {
                id: id,
                warehouse_name: values.warehouse_name,
                warehouse_code: values.warehouse_code,
                warehouse_contact_person: values.warehouse_contact_person,
                email: values.email,
                status: values.status,
                fssai_license_no: values.fssai_license_no,
                city: values.city,
                street: values.street,
                area_code: values.area_code,
                state: values.state,
                latitude: values.latitude,
                longitude: values.longitude,
                city_code: values.city_code,
                locality: values.locality
            };
            const url = id ? `${apiEndpoint}/warehouse/update` : `${apiEndpoint}/warehouse`;
            const response = await axios.post(
                url,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    },
                }
            );
            setIsLoading(false);
            // getWarehouseById();
            router.push('/warehouse?tab=shopdetails');
            console.log("Warehouse API Response --->", response.data);
        } catch (error) {
            setIsLoading(false);
            console.error("API Error --->", error.response?.data || error.message);
        }
    };

    const getWarehouseById = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(
                `${apiEndpoint}/get-warehouse-list?id=${id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    }
                }
            );
            const data = response?.data?.data;
            console.log("Warehouse Details --->", data?.warehouse_contact_person);
            if (data) {
                form.setFieldsValue({
                    warehouse_name: data.warehouse_name,
                    warehouse_code: data.warehouse_code,
                    email: data.email,
                    warehouse_contact_person: data.warehouse_contact_person,
                    state: data.state,
                    city: data.city,
                    area_code: data.area_code,
                    street: data.street,
                    locality: data.locality,
                    status: data.status,
                    fssai_license_no: data.fssai_license_no,
                });
            }
            if (data.warehouse_name && data.warehouse_code && data.email && data.warehouse_contact_person && data.state && data.city) {
                setSectionStatus(prev => ({ ...prev, address: true }));
            }
        } catch (error) {
            console.log("Get By ID Error --->", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            getWarehouseById();
        }
    }, [id]);


    const [schedule, setSchedule] = useState({});
    console.log("schedule----->", schedule)
    const days = [
        { label: 'Monday', value: 1 },
        { label: 'Tuesday', value: 2 },
        { label: 'Wednesday', value: 3 },
        { label: 'Thursday', value: 4 },
        { label: 'Friday', value: 5 },
        { label: 'Saturday', value: 6 },
        { label: 'Sunday', value: 7 },
    ];


    const handleTimeChange = (day, index, time) => {
        setSchedule(prev => {
            const updatedDay = [...(prev[day] || [])];

            updatedDay[index] = time; // store dayjs objects

            return {
                ...prev,
                [day]: updatedDay
            };
        });
    };


    const addShift = (day) => {
        console.log(day)
        setSchedule(prev => ({
            ...prev,
            [day]: [...(prev[day] || []), []],
        }));
    };

    const buildPayload = () => {
        let payload;

        if (haveDifferentTime === true) {
            let t = days.map(day => ({
                day_of_week: day.value,
                is_closed: !schedule[day.value]?.length,
                shifts: (schedule[day.value] || []).map(shift => ({
                    opening_time: shift[0].format("HH:mm:ss"),
                    closing_time: shift[1].format("HH:mm:ss"),
                })),
            }));
            payload = t;
            console.log(t)
        } else {
            console.log("allWeekTime--->", allWeekTime)
            let t = days.map(day => ({
                day_of_week: day.value,
                is_closed: false,
                shifts: [{
                    opening_time: allWeekTime[0],
                    closing_time: allWeekTime[1],
                }],
            }));
            payload = t;
            console.log(t)
        }
        updateWarehouseTime(payload)
        console.log(payload)
    };

    const updateWarehouseTime = async (operatingHours) => {
        try {
            setIsLoading(true);
            const payload = {
                warehouse_id: id,
                warehouse_location_id: locationId,
                operating_hours: operatingHours
            };

            const response = await axios.post(
                `${apiEndpoint}/update-warehouse-time`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    }
                }
            );
            toast.success(response?.data?.message);
            router.push('/warehouse?tab=shopdetails');
        } catch (error) {
            toast.error("Failed to update warehouse timings");
            console.error("Time Update Error --->", error.response?.data || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const getwarehouseTime = async () => {
        try {
            const response = await axios.get(
                `${apiEndpoint}/get-warehouse-time?warehouse_id=${id}&warehouse_location_id=${locationId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    }
                }
            );
            if (response?.data?.operating_hours?.length > 0) {
                setSectionStatus(prev => ({ ...prev, time: true }));
                const scheduleData = {};
                response.data.operating_hours.forEach(item => {
                    if (!item.is_closed) {
                        scheduleData[item.day_of_week] = item.shifts.map(shift => [
                            dayjs(shift.opening_time, "HH:mm:ss"),
                            dayjs(shift.closing_time, "HH:mm:ss")
                        ]);
                    } else {
                        scheduleData[item.day_of_week] = [];
                    }
                });
                setSchedule(scheduleData);
                setHaveDifferentTime(true);
            }
            console.log("Warehouse Time --->", response.data);
        } catch (error) {
            console.log("Get Warehouse Time Error --->", error.response?.data || error.message);
        }
    };
    const getwarehouseFeature = async () => {
        try {
            const response = await axios({
                method: "POST",
                url: `${apiEndpoint}/get-seller-level-feature`,
                headers: {
                    "Content-Type": "application/json",
                    "X-Custom-Authorization": `Bearer ${rawToken}`
                },
                data: {
                    "warehouse_id": id,
                    "warehouse_location_id": locationId
                }


            });

            if (response.status === 200) {
                const inventoryTypes = response.data.data?.map(
                    item => item?.feature
                );

                Feature.setFieldsValue({
                    inventoryTypeState: inventoryTypes
                });
            }

        } catch (error) {
            console.log("Get Warehouse Time Error --->", error.response?.data || error.message);
        }
    };

    useEffect(() => {
        if (id && locationId) {
            getwarehouseTime();
            getwarehouseFeature();
        }
    }, [id, locationId]);


    const Dropdownitems = [
        {
            key: '1',
            label: (
                <span onClick={() => router.push(`/warehousefulfillment/${id}/${locationId}`)}>
                    Fulfillments
                </span>
            ),
        },
        {
            key: '2',
            label: (
                <span onClick={() => router.push(`/warehouseserviceability?id=${id}&warehouse_location_id=${locationId}`)}>
                    Serviceability
                </span>
            ),
        },
        {
            key: '3',
            label: (
                <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com">
                    3rd menu item
                </a>
            ),
        },
    ];


    let rawToken = sessionStorage.getItem("us_st_d");
    var decode = jwt_decode(rawToken);
    // console.log(decode)
    const seller_provider_id = decode?.data?.seller_data?.provider_id;
    const { baseNodeapiUrl, apiEndpoint } = config;
    const [allCities, setallcities] = React.useState([]);

    useEffect(() => {
        getCities()

    }, [])


    async function getCities() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getcity`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                }
            })

            if (data.status == 200) {
                setallcities(data.data)
                console.log(data.data)
            }
        } catch (err) {
            console.log(err)
        }


    }


    const [fileList, setFileList] = useState([]);
    const handleChequeUpload = async ({ file, onSuccess, onError }) => {
        try {
            const formData = new FormData();
            formData.append("files", file);
            const { data } = await axios.post(
                "https://stage.myindiabazar.com/products/upload",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            if (data?.success) {
                const fileUrl = data?.urls?.[0];
                Bankform.setFieldsValue({
                    cancelled_cheque_url: fileUrl
                });
                setFileList([
                    {
                        uid: file.uid,
                        name: file.name,
                        status: "done",
                        url: fileUrl
                    }
                ]);
                toast.success(data?.message || "File uploaded successfully");
                onSuccess(data, file);
            } else {
                toast.error(data?.message || "Upload failed");
                onError("Upload failed");
            }
        } catch (error) {
            console.log(error);
            toast.error("Upload failed");
            toast.error(error.message);
            onError(error);
        }
    };

    const handleBankSubmit = async (values) => {
        try {
            setIsLoading(true);
            const payload = {
                warehouse_id: id,
                warehouse_location_id: locationId,
                account_holder_name: values.account_holder_name,
                bank_name: values.bank_name,
                account_number: values.account_number,
                ifsc_code: values.ifsc_code,
                branch_name: values.branch_name,
                cancelled_cheque_url: values.cancelled_cheque_url || ""
            };
            const response = await axios.post(
                `${apiEndpoint}/add-bank-details`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    }
                }
            );
            toast.success('Bank account saved successfully');
            router.push('/warehouse?tab=shopdetails');
            console.log("Bank API Response --->", response.data);
        } catch (error) {
            console.error("Bank API Error --->", error.response?.data || error.message);
            toast.error("Failed to add bank details");
        } finally {
            setIsLoading(false);
        }
    };

    const getBankDetails = async () => {
        try {
            const response = await axios.get(
                `${apiEndpoint}/get-warehouse-bank-details?warehouse_id=${id}&warehouse_location_id=${locationId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    }
                }
            );
            const data = response?.data?.data;
            console.log("Bank Details --->", data);
            if (data) {
                Bankform.setFieldsValue({
                    account_holder_name: data.account_holder_name,
                    bank_name: data.bank_name,
                    account_number: data.account_number,
                    ifsc_code: data.ifsc_code,
                    branch_name: data.branch_name,
                    cancelled_cheque_url: data.cancelled_cheque_url
                });
                setSectionStatus(prev => ({ ...prev, bank: true }));
            }
            if (data.cancelled_cheque_url) {
                setFileList([
                    {
                        uid: "-1",
                        name: "cancelled_cheque URL",
                        status: "done",
                        url: data.cancelled_cheque_url
                    }
                ]);
            }
        } catch (error) {
            console.log("Get Bank Details Error --->", error);
            const errorMessage = error?.response?.data?.message || "Something went wrong";
            toast.error(errorMessage);
        }
    };

    useEffect(() => {
        if (id && locationId) {
            getBankDetails();
        }
    }, [id, locationId]);


    async function featureSubmitHandler() {

        try {

            const values = await Feature.validateFields();

            const response = await axios({
                method: "post",
                url: `${apiEndpoint}/update-seller-level-feature`,
                data: {
                    warehouse_id: id,
                    warehouse_location_id: locationId,
                    feature: values.inventoryTypeState,
                    status: 1
                },

                headers: {
                    "Content-Type": "application/json",
                    "X-Custom-Authorization": `Bearer ${rawToken}`
                }
            });

            if (
                response?.status === 200 &&
                response.data.status === 200
            ) {
                toast.success("Updated successfully !!");
            } else {
                toast.error("Something went wrong!");
            }

            console.log("response--->", response);

        } catch (error) {

            console.log(
                "Submit Error --->",
                error.response?.data || error.message
            );

            toast.error("Something went wrong!");
        }
    }

    const items = [
        {
            key: '1',
            label: (<div className='d-flex ' style={{ gap: "14px" }}>
                <span style={{ fontWeight: 600 }}>Warehouse address & basic details</span>
                {sectionStatus.address ?
                    <FaCheckCircle color="green" size={18} /> :
                    <FaExclamationCircle color="orange" size={18} />
                }
            </div>
            ),
            children: <div>
                <Form
                    {...formItemLayout}
                    form={form}
                    name="register"
                    onFinish={onFinish}
                    initialValues={{ residence: ['zhejiang', 'hangzhou', 'xihu'], prefix: '91' }}
                    scrollToFirstError
                    style={{ height: "55vh", overflow: "scroll", scrollbarWidth: "none" }}>

                    <Form.Item name="warehouse_name" label="Warehouse name" labelAlign="left" rules={[{ required: true, message: 'Please enter warehouse name!', whitespace: true }]}><Input /></Form.Item>

                    <Form.Item name="warehouse_code" label="Warehouse Code" labelAlign="left" rules={[{ required: true, message: 'Please enter warehouse code!', whitespace: true }]}><Input /></Form.Item>

                    <Form.Item name="email" label="Contact E-mail:" labelAlign='left' rules={[{ type: 'email', message: 'The input is not valid E-mail!' }, { required: true, message: 'Please input your E-mail!' }]}><Input /></Form.Item>

                    <Form.Item name="warehouse_contact_person" label="Contact Number" rules={[{ required: true, message: 'Please input your phone number!' }, { type: 'text', message: 'The input is not valid phone number!' }]} labelAlign='left'><Input style={{ width: '100%' }} /></Form.Item>

                    <Form.Item name="state" label="Select State" labelAlign='left' rules={[{ required: true, message: 'State is required' }]}><Select placeholder="Select state" options={states?.map(item => { return { label: item?.name, value: item?.iso2 } })} onChange={(value) => setSelectedState(value)} /></Form.Item>

                    <Form.Item name="city" label="Select City" labelAlign='left' rules={[{ required: true, message: 'City is required' }]}><Select placeholder="Select City" options={cities?.map(item => { return { label: item?.name, value: item?.name } })} /></Form.Item>

                    <Form.Item name="area_code" label="Pincode" labelAlign="left" rules={[{ required: true, message: 'Please enter pincode!', whitespace: true }]}><Input /></Form.Item>

                    <Form.Item name="street" label="Street" labelAlign="left" rules={[{ required: true, message: 'Please enter warehouse code!', whitespace: true }]}><Input /></Form.Item>

                    <Form.Item name="locality" label="Locality" labelAlign="left" rules={[{ required: true, message: 'Please enter warehouse code!', whitespace: true }]}><Input /></Form.Item>

                    <Form.Item name="status" label="Select Status" labelAlign='left' rules={[{ required: true, message: 'Status is required' }]}><Select placeholder="Select Status" options={[{ name: "Open", status: true }, { name: "Closed", status: false }]?.map(item => { return { label: item?.name, value: item?.status } })} onChange={(value) => setSelectedState(value)} /></Form.Item>

                    <Form.Item name="fssai_license_no" label="FSSAI License Number" labelAlign="left" rules={[{ required: false, message: 'Please enter FSSAI License Number!', whitespace: true }]}><Input /></Form.Item>

                    <Form.Item {...tailFormItemLayout}><button className="btn btn-primary" htmlType="submit" style={{ width: "200px", borderRadius: "20px" }}>{id ? "Update Warehouse" : "Add Warehouse"}</button></Form.Item>
                </Form>
            </div>
        },


        ...(id ? [
            {
                key: '2',
                label: (<div className='d-flex' style={{ gap: "14px" }}>
                    <span style={{ fontWeight: 600 }}>
                        Warehouse timings
                    </span>
                    {sectionStatus.time ?
                        <FaCheckCircle color="green" size={18} /> :
                        <FaExclamationCircle color="orange" size={18} />
                    }
                </div>
                ),
                children: <div>
                    <div className='mb-2'>
                        <Checkbox checked={haveDifferentTime} onChange={onCheckboxChange}>Have different open hours for each day of the week?</Checkbox>
                    </div>

                    {haveDifferentTime ? <>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: '24px',
                            }}
                        >
                            {days.map(day => (
                                <div
                                    key={day.value}
                                    style={{
                                        border: '1px solid #eee',
                                        padding: 12,
                                        borderRadius: 6,
                                    }}
                                >
                                    <strong>{day.label}</strong>

                                    {(schedule[day.value] || [[]]).map((shift, index) => (
                                        <div key={index} className="d-flex align-items-center gap-2 mt-2">
                                            <TimePicker.RangePicker
                                                format="HH:mm"
                                                value={shift?.length ? shift : null}
                                                onChange={(time) => handleTimeChange(day.value, index, time)}
                                            />
                                        </div>
                                    ))}

                                    {/* <Button
                                    type="link"
                                    onClick={() => addShift(day.value)}
                                    style={{ paddingLeft: 0 }}
                                >
                                    + Add shift
                                </Button> */}

                                    <Tag color="green" onClick={() => addShift(day.value)}
                                        style={{ paddingLeft: "2px" }} className='mt-2'>
                                        + Add shift
                                    </Tag>
                                </div>
                            ))}
                        </div>
                    </> :
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                            <TimePicker.RangePicker onChange={onChange} />
                            <label htmlFor="">Open hours (everyday)</label>
                        </div>}
                    <div className='d-flex justify-content-center mt-3'>
                        <button className="btn btn-primary mt-3 ml-2" htmlType="submit" style={{ borderRadius: "20px" }} type="primary" onClick={() => { buildPayload() }} >
                            {id ? "Update warehouse timings" : "Submit warehouse timings"}
                        </button>
                    </div>
                </div>,
            },

            {
                key: '3',
                label: (<div className='d-flex' style={{ gap: "14px" }}>
                    <span style={{ fontWeight: 600 }}>
                        Features
                    </span>
                    {sectionStatus.time ?
                        <FaCheckCircle color="green" size={18} /> :
                        <FaExclamationCircle color="orange" size={18} />
                    }
                </div>
                ),
                children: <div>
                    <Form
                        {...formItemLayout}
                        form={Feature}
                        name="feature"
                        // onFinish={onFinish}

                        // style={{ maxWidth: 600 }}
                        scrollToFirstError>
                        <Form.Item
                            name="inventoryTypeState"
                            label="Select inventory type"
                            labelAlign="left"
                            rules={[
                                {
                                    required: true,
                                    message: "Inventory type is required"
                                }
                            ]}
                        >
                            <Select
                                mode="multiple"
                                placeholder="Select inventory type"
                                options={[
                                    { name: "Default", value: "default" },
                                    { name: "Inventory less", value: "inventory_less" }
                                ].map(item => ({
                                    label: item.name,
                                    value: item.value
                                }))}
                            />
                        </Form.Item>

                        <Form.Item {...tailFormItemLayout}>
                            <button onClick={() => featureSubmitHandler()} className="btn btn-primary" htmlType="submit" style={{ width: "200px", borderRadius: "20px" }}>
                                {id ? "Update " : "Submit"}
                            </button>
                        </Form.Item>
                    </Form>

                </div>,
            },


            {
                key: '4',
                label: (<div className='d-flex ' style={{ gap: "14px" }}>
                    <span style={{ fontWeight: 600 }}>
                        Bank details
                    </span>
                    {sectionStatus.bank ?
                        <FaCheckCircle color="green" size={18} /> :
                        <FaExclamationCircle color="orange" size={18} />
                    }
                </div>
                ),
                children: <div>
                    <Form
                        {...formItemLayout}
                        form={Bankform}
                        name="bankform"
                        onFinish={handleBankSubmit}
                        initialValues={{ residence: ['zhejiang', 'hangzhou', 'xihu'], prefix: '91' }}
                        scrollToFirstError
                        style={{ height: "55vh", overflow: "scroll", scrollbarWidth: "none" }}
                    >
                        <Form.Item name="account_holder_name" label="Account holder name" labelAlign="left" rules={[{ required: true, message: 'Please enter account holder name!', whitespace: true }]}><Input /></Form.Item>

                        <Form.Item name="bank_name" label="Bank name" labelAlign="left" rules={[{ required: true, message: 'Please enter bank name!', whitespace: true }]}><Input /></Form.Item>

                        <Form.Item name="account_number" label="Account number" labelAlign="left" rules={[{ required: true, message: 'Please input your account number!' }, { pattern: /^[0-9]{8,18}$/, message: 'Account number must be 8–18 digits' }]}><Input inputMode="numeric" maxLength={18} /></Form.Item>

                        <Form.Item name="ifsc_code" label="IFSC code" labelAlign="left" rules={[{ required: true, message: 'Please enter ifsc code!', whitespace: true }]}><Input /></Form.Item>

                        <Form.Item name="branch_name" label="Branch name" labelAlign="left" rules={[{ required: true, message: 'Please enter branch name!', whitespace: true }]}><Input /></Form.Item>

                        <Form.Item label="Cancelled Cheque" labelAlign="left" required><Upload customRequest={handleChequeUpload} maxCount={1} accept=".png,.jpg,.jpeg,.pdf" fileList={fileList} onChange={({ fileList }) => setFileList(fileList)}><Button icon={<UploadOutlined />}>Click to Upload</Button></Upload></Form.Item>

                        <Form.Item name="cancelled_cheque_url" hidden rules={[{ required: true, message: "Please upload cancelled cheque!" }]}><Input /></Form.Item>

                        <Form.Item {...tailFormItemLayout}><button className="btn btn-primary" htmlType="submit" style={{ width: "200px", borderRadius: "20px" }}>{id ? "Update Bank Details" : "Add Bank Details"}</button></Form.Item>
                    </Form>
                </div>,
            },
        ] : []),
    ];

    return (
        <ThemeMaker>

            <div className="mcrb-page">
                <div className="mcrb-card">
                    <div className="mcrb-headbar">
                        <span>{id ? "Update Warehouse" : "Add Warehouse"}</span>
                        <Dropdown menu={{ items: Dropdownitems }} placement="bottomRight">
                            <button type="button">Configurations ▾</button>
                        </Dropdown>
                    </div>
                    <div className="mcrb-antdform" style={{ maxHeight: "78vh", overflowY: "auto", scrollbarWidth: "none" }}>
                        <Collapse items={items} defaultActiveKey={['1']} onChange={onAccordianChange} />
                    </div>
                </div>
            </div>
        </ThemeMaker>
    )
}
